import { Injectable } from "@angular/core";
import { FormControlStatus, FormGroup } from "@angular/forms";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { RetailStock } from "src/app/retail-common.service";
import { TransactionSearchService } from "./transaction-search.service";


export class TransactionSearchState extends BaseFpxComponentState {
  transPeriod: string;
  defaultDate: any;
  placeholder: any = "DD/MM/YYYY";
}


@Injectable()
export class TransactionSearchHelper extends BaseFpxFormHelper<TransactionSearchState> {
  constructor(
    private transactionSearchService: TransactionSearchService,
    private _retailStock: RetailStock
  ) {
    super(new TransactionSearchState());
    this.addChangeHandler("transPeriod", this.doTransPeriodChange);
    this.addChangeHandler("fromDate", this.fromDateChange);
  }

  public doConfirm(context: any, success: any, failure: any) {}
  private doTransPeriodChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    if (value == "1") {
      formGroup.controls["month"].reset();
      formGroup.controls["year"].reset();
      formGroup.controls["fromDate"].reset();
      formGroup.controls["toDate"].reset();

      formGroup.controls["month"].disable();
      formGroup.controls["year"].disable();
      formGroup.controls["fromDate"].disable();
      formGroup.controls["toDate"].disable();
    } else if (value == "2") {
      formGroup.controls["fromDate"].reset();
      formGroup.controls["toDate"].reset();

      formGroup.controls["month"].enable();
      formGroup.controls["year"].enable();
      formGroup.controls["fromDate"].disable();
      formGroup.controls["toDate"].disable();
    } else if (value == "3") {
      formGroup.controls["month"].reset();
      formGroup.controls["year"].reset();
      formGroup.controls["month"].disable();
      formGroup.controls["year"].disable();
      formGroup.controls["fromDate"].enable();
      formGroup.controls["toDate"].enable();

      this.state.placeholder = "DD/MM/YYYY";

      formGroup
        .get("fromDate")
        .patchValue(this.state.defaultDate, { emitEvent: false });

      formGroup
        .get("toDate")
        .patchValue(this.state.defaultDate, { emitEvent: false });
    }
    this.state.transPeriod = value;
  };

  private fromDateChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    // formGroup.get("toDate").reset({ emitEvent: false });
  };

  public doSubmit(methodName, context: any, success: any, failure: any) {
    context = { ...context };
    this.transactionSearchService[methodName](context).subscribe(
      (res) => {
        success(res);
      },
      (err) => {
        failure(err);
      }
    );
  }
}